import React, { memo } from "react";

import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Stack,
  Text,
} from "@chakra-ui/react";
import {
  IHelpModal,
  useOverlay,
} from "modules/providers/overlay-provider/overlay-provider";
import colors from "app/colors";

interface IProps {
  helpModal: IHelpModal;
  onSaveCallback: Function;
}

const ConfirmModal = ({ helpModal, onSaveCallback }: IProps) => {
  const { closeModal } = useOverlay();

  const onConfirmClicked = () => {
    onSaveCallback();
    closeModal();
  };

  return (
    <Modal isOpen onClose={closeModal} size="sm" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalBody p={8}>
          <Stack w="full" alignItems="center" spacing={4}>
            {helpModal.icon}
            {helpModal.title && (
              <Text
                fontWeight={600}
                fontSize={24}
                fontFamily="Outfit"
                color={colors.blackSecondary}
              >
                {helpModal.title}
              </Text>
            )}
            {helpModal.message && (
              <Text
                fontWeight={500}
                fontSize={14}
                color={colors.gray50}
                textAlign="center"
              >
                {helpModal.message}
              </Text>
            )}
            <HStack>
              <Button variant="cancel" w={140} h={50} onClick={closeModal}>
                Cancel
              </Button>
              <Button
                w={140}
                h={50}
                onClick={onConfirmClicked}
                fontWeight={700}
                fontSize={16}
              >
                Confirm
              </Button>
            </HStack>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default memo(ConfirmModal);
